import React from 'react';
import { Col, Row } from 'reactstrap';

import defaultImage from '../../../assets/img/components/User/Login/pw-background-plane-shiny.png';
import history from '../../../utils/history';
// import StaticResource from './staticResource';
import FeaturedResource from './featuredResource';

class ResourcesView extends React.Component {
  UNSAFE_componentWillMount() {
    // this.props.getFeaturedForum();
    if (!this.props.featuredBlog[0]) this.props.getFeaturedBlog();
    // this.props.getFeaturedPodcast();
  }

  handlePracticeExam = () => {
    history.push('/app/practice-exam');
  };

  render() {
    return (
      <div className="resources-container">
        <Row>
          {/* <Col xs={12} className="mt-3">
            <StaticResource
              activeButton={this.props.practiceExamAvailable}
              title="Practice with a 100-Question Mock Exam"
              description="Just like the real deal, the practice exam is timed and mimics what you'll see on exam day."
              link="#"
              buttonLabel="LAUNCH EXAM"
              onClick={this.handlePracticeExam}
            />
          </Col> */}
          {/* three featured resources */}

          <Col xs={12} className="mt-3">
            {this.props.featuredBlogIsLoading ? (
              <FeaturedResource
                title="FEATURED BLOG"
                description="LOADING..."
                imageUrl={defaultImage}
              />
            ) : (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  this.props.featuredBlog && this.props.featuredBlog.link
                    ? this.props.featuredBlog.link
                    : 'https://promotionwingman.com/how-to-submit-a-publication/'
                }
              >
                <FeaturedResource
                  title="FEATURED BLOG"
                  description={
                    this.props.featuredBlog &&
                    this.props.featuredBlog.title?.rendered
                      ? this.props.featuredBlog.title.rendered
                      : 'How to submit a publication'
                  }
                  imageUrl={
                    this.props.featuredBlog[0] &&
                    this.props.featuredBlog[0]._embedded['wp:featuredmedia']
                      ? this.props.featuredBlog[0]._embedded[
                          'wp:featuredmedia'
                        ][0].source_url
                      : defaultImage
                  }
                />
              </a>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}
export default ResourcesView;
